import React from 'react';

import {
  ApplyButton,
  ApplyFiltersButton,
  AllFiltersButton,
  Filters as GoGameFilters,
  FiltersCollection as GoGameFiltersCollection,
} from '@gogame/filters';
import {
  Screen,
  useScreenState,
  useScreenDispatch,
  useScreenTitle,
  useScreenName,
  SET_FILTERS,
} from '@gogame/screens';

import withFavorites from './withFavorites';

export {
  GoGameFilters as GoGameFiltersWithoutFavorites,
  ApplyButton,
  ApplyFiltersButton,
};

export const Filters = withFavorites(GoGameFilters);
export const FiltersCollection = withFavorites(GoGameFiltersCollection);

export { default as AllFilters } from './AllFilters';
export { default as PrimaryFilters } from './PrimaryFilters';
export { default as UnAppliedChanges } from './UnAppliedChanges';

export const ScreenFiltersCollection = ({ children, ...props }) => {
  const screenState = useScreenState();
  const dispatch = useScreenDispatch();
  const title = useScreenTitle();
  const name = useScreenName();
  const handleSetFilters = (filtersCollection) => {
    dispatch({
      type: SET_FILTERS,
      payload: filtersCollection,
    });
  };

  return (
    <FiltersCollection
      initialValues={screenState.filtersCollection}
      onApply={handleSetFilters}
      screen={name}
      title={title}
      {...props}
    >
      {children}
    </FiltersCollection>
  );
};

export const ScreenFilters = ({ children, ...props }) => {
  const screenState = useScreenState();
  const dispatch = useScreenDispatch();
  const title = useScreenTitle();
  const name = useScreenName();

  const handleSetFilters = (filters) => {
    dispatch({
      type: SET_FILTERS,
      payload: filters,
    });
  };

  return (
    <Filters
      initialValues={screenState.filters}
      initialDirty={!screenState.ready}
      onApply={handleSetFilters}
      screen={name}
      title={title}
      {...props}
    >
      {children}
    </Filters>
  );
};

export const ScreenAllFilters = ({ sidePage, params, badge, badgeColor }) => {
  return (
    <Screen.Toolbar.AllFilters>
      <AllFiltersButton
        sidePage={sidePage}
        params={params}
        badge={badge}
        badgeColor={badgeColor}
      />
    </Screen.Toolbar.AllFilters>
  );
};

export const ScreenFiltersApply = () => {
  return (
    <Screen.Toolbar.FiltersApply>
      <ApplyFiltersButton />
    </Screen.Toolbar.FiltersApply>
  );
};
export default Filters;
